import { Flex, Form, Select, Switch } from "antd";
import { DefaultOptionType } from "antd/es/select";
import React, { useMemo } from "react";
import { ZCopyByValueRule } from "src/common/attrEdit/ZCopyByValueRule";
import { ZUid } from "src/types/zUid";
import { ZAvaliableCopyAttrData } from "../../CopyByValueEdit.types";
import styles from "./DictSingleAttrCopySettings.module.less";

export const filedNamesDictSingleAttrCopy = {
  withRestrictions: "withRestrictions",
  groupIdsToCopy: "groupIdsToCopy",
} satisfies Partial<Record<keyof ZCopyByValueRule, string>>;

interface PropsDictSingleAttrCopyProps {
  avaliableCopyAttrData: ZAvaliableCopyAttrData[];
  curLinkAttrId: ZUid | undefined;
  curCopySrcAttrId: ZUid | undefined;
}

export const DictSingleAttrCopyProps: React.FC<
  PropsDictSingleAttrCopyProps
> = ({ curLinkAttrId, curCopySrcAttrId, avaliableCopyAttrData }) => {
  const avaliableLinkAttrsMap = new Map(
    avaliableCopyAttrData.map((e) => [e.linkAttributeId, e]),
  );
  const copySrcAttributes =
    avaliableLinkAttrsMap.get(curLinkAttrId || "")?.attributes || [];
  const copySrcAttributesMap = new Map(copySrcAttributes.map((e) => [e.id, e]));
  const currCopySrcAttr = copySrcAttributesMap.get(curCopySrcAttrId || "");
  const groupsByDict = currCopySrcAttr?.groupByDictionary || [];
  const restrAttrName = currCopySrcAttr?.restrictionName;

  const groupByDictOpts: DefaultOptionType[] = useMemo(
    () =>
      groupsByDict.map(({ id, name }) => ({
        value: id,
        label: name,
      })),
    [groupsByDict],
  );

  return (
    <>
      <Flex vertical gap={8} className={styles.withRestr}>
        <Flex align="center" justify="space-between">
          <div className={styles.withRestrTitle}>
            Перенести ограничения по значениям
          </div>
          <Form.Item name={filedNamesDictSingleAttrCopy.withRestrictions}>
            <Switch disabled={!restrAttrName} />
          </Form.Item>
        </Flex>
        {restrAttrName ? (
          <div>{`Справочник ${restrAttrName} будет перенесён в связанный объект`}</div>
        ) : (
          "У справочника из поля для сравнения нет ограничений по значению"
        )}
      </Flex>
      <Form.Item
        name={filedNamesDictSingleAttrCopy.groupIdsToCopy}
        label="Группы на основе справочника для копирования"
        tooltip="Если выбранные группы на основе справочника уже существуют в текущем объекте, то копирование групп не произойдет"
      >
        <Select
          options={groupByDictOpts}
          disabled={!curCopySrcAttrId}
          placeholder={
            !curCopySrcAttrId
              ? "Сначала необходимо выбрать поле для сравнения"
              : "Выберите группы на основе справочника"
          }
          allowClear
          mode="multiple"
        />
      </Form.Item>
    </>
  );
};
